import { render, staticRenderFns } from "./VJoinUs.vue?vue&type=template&id=1f7f1ad8&scoped=true"
import script from "./VJoinUs.vue?vue&type=script&lang=ts"
export * from "./VJoinUs.vue?vue&type=script&lang=ts"
import style0 from "./VJoinUs.vue?vue&type=style&index=0&id=1f7f1ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f1ad8",
  null
  
)

export default component.exports